import { Box, Center, Flex, Icon } from '@chakra-ui/react'
import { File04Icon, Monitor02Icon } from '../../assets/icons' // Replace with your actual icon imports

type DocumentContentSwitchProps = {
  viewing: 'content' | 'documents';
  setViewing: (view: 'content' | 'documents') => void;
};

const DocumentContentSwitch = ({ viewing, setViewing }: DocumentContentSwitchProps) => {
  return (
    <Flex
      w="140px"
      h="40px"
      p="3px"
      borderRadius="8px"
      borderColor="solid.100"
      borderWidth="1px"
      pos="relative"
      justifyContent="space-between"
      alignItems="center"
      transition="0.2s ease-out"
      _focus={{
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        outline: 'solid.100',
      }}
      _hover={{
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        outline: 'solid.100',
      }}
    >
      <Box
        transition="0.2s ease-out"
        pos="absolute"
        w="65px"
        h="32px"
        bg="solid.50"
        borderRadius="5.5px"
        left={viewing === 'content' ? '3px' : '72px'}
        top="3px"
      />
      <Center
        w="65px"
        pos="absolute"
        left="3px"
        cursor="pointer"
        color={viewing === 'content' ? 'solid.900' : 'solid.500'}
        onClick={() => setViewing('content')}
      >
        <Icon w="20px" h="20px" viewBox="0 0 24 24" fill="none">
          <Monitor02Icon />
        </Icon>
      </Center>
      <Center
        w="65px"
        pos="absolute"
        right="3px"
        cursor="pointer"
        color={viewing === 'documents' ? 'solid.900' : 'solid.500'}
        onClick={() => setViewing('documents')}
      >
        <Icon w="20px" h="20px" viewBox="0 0 24 24" fill="none">
          <File04Icon />
        </Icon>
      </Center>
    </Flex>
  );
};

export default DocumentContentSwitch;
